module.exports = __webpack_public_path__ + "static/media/esports_logo.052fd78f.png";